import client from "@/api";

export const getCandidateFiles = async (candidateID) => {
  return await client.get(`/candidate/${candidateID}/files`);
};

export const regenerateQAResume = async ({ candidateID, data }) => {
  return await client.post(`/regenerate-opt/${candidateID}`, data);
};
